/* eslint-disable import/no-cycle */
import { FETCH_KPI_ACTIVITIES } from "lib/constants";
import { getAPICall } from "../lib/callApi";

export const fetchCompanyKpis = async (payload) => {
  const data = await getAPICall(FETCH_KPI_ACTIVITIES, true, payload);
  return data;
};
